module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-500-03bb29d6722bf52f7fe88a6ed47d9e6e.eot";